import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export type PageHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
};

/**
 * PageHeader — consistent top region for admin/curator/student pages.
 * Uses the brand's "active whitespace" — title sits asymmetrically left.
 */
export function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <header className={cn('mb-8 flex flex-wrap items-end justify-between gap-4', className)}>
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-display text-on-surface md:text-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm text-on-surface-variant md:text-base">{subtitle}</p>
        )}
      </div>
      {/* flex-wrap: четыре кнопки карточки пользователя на узкой ширине делали страницу шире экрана (техдолг 334). */}
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
